import {
  Component
} from "react";
import {
  Obj
} from '../../lib/Object.lib';
import {
  Str,
  trim
} from '../../lib/String.lib';
import Box from '../Layout/Wrappers/Box';
import Divider from '../Layout/Wrappers/Divider';
import IconButton from '../Layout/Wrappers/IconButton';
import TextField from '../Layout/Wrappers/TextField';
import Typography from '../Layout/Wrappers/Typography';
import TagAttributeList from "./TagAttributeList";

class TagBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tag: Obj(props.tag),
      changes: false,
    };
  }
  save = (event) => {
    const {
      onUpdate = () => { },
      onArchived = () => { }
    } = this.props;
    const tag = Obj(event.tag || this.state.tag);
    // ON ARCHIVE/UNARCHIVE TAG
    if (event.tag) {
      const { archived } = event.tag;
      this.setState({ tag: event.tag }, () => {
        archived
          ? onArchived(event.tag)
          : onUpdate(event.tag);
      });
    }
    // ON SAVE
    else if (this.state.changes) {
      const { archived } = this.state.tag;
      this.setState({
        changes: false,
        // RESET LOCAL STATE ON SAVING NEW
        tag: this.props.isNew ? {} : tag
      }, () => {
        archived
          ? onArchived(tag)
          : onUpdate(tag);
      });
    }
  };
  focus = (em) => {
    this.textField && this.textField.focus();
  };
  render() {
    const {
      isNew,
      divider = true,
    } = this.props;
    if (/categories/i.test(this.state.tag.key)) {
      return <div />;
    }

    const _onKeyPress = (event) => {
      if (
        !!Str(event.key).match(/enter|tab/i)
      ) {
        this.save(event);
      }
    }

    return (
      <>
        {!isNew && divider && <Divider className="m-0" />}
        <div className="hover-bg p-1 w-100">
          <Box row noWrap>
            {!this.props.isNew && (
              <Typography small className='mr-2'>
                id: {this.state.tag.id}
              </Typography>
            )}
            <Box row noWrap mr>
              <Typography small mr>
                Label:
              </Typography>
              <TextField disabledBlurExport
                ref={(tf) => (TagBox.textField = tf)}
                name={this.props.name}
                placeholder={this.props.placeholder}
                value={this.state.tag.label}
                onChange={(ev, change) => {
                  this.setState((state) => {
                    state.changes = !!trim(change);
                    state.tag.label = change;
                    return state;
                  });
                }}
                onKeyPress={_onKeyPress}
                disabled={this.state.tag.archived}
              />
            </Box>
            {
              (
                this.state.tag.archived
              ) ? (
                <IconButton
                  onClick={(event) => {
                    const tag = { ...this.state.tag };
                    tag.archived = false;
                    this.save({ tag });
                  }}
                >
                  <i className="material-icons">unarchive</i>
                </IconButton>
              ) : (
                this.state.changes
                && (
                  <IconButton onClick={this.save}>
                    <i className="material-icons c-orange">save</i>
                  </IconButton>
                )
              )
            }
            {!this.props.isNew && !this.state.tag.archived && (
              <IconButton
                onClick={(ev) => {
                  const tag = { ...this.state.tag };
                  tag.archived = true;
                  this.save({ tag });
                }}
              >
                <i className="material-icons">archive</i>
              </IconButton>
            )}
          </Box>
          <blockquote>
            <TagAttributeList
              category={this.props.category}
              tag={this.state.tag}
              disabled
              onChange={
                tag => {
                  this.setState((state) => {
                    state.tag = tag;
                    state.changes = true;
                    return state;
                  });
                }
              }
            />
          </blockquote>
        </div>
      </>
    );
  }
}
export default TagBox;
